"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var ReactDom = _interopRequireWildcard(require("react-dom"));

var mobx = _interopRequireWildcard(require("mobx"));

var mst = _interopRequireWildcard(require("mobx-state-tree"));

var mxreact = _interopRequireWildcard(require("mobx-react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var MUIStyles = _interopRequireWildcard(require("@material-ui/core/styles"));

var MUICore = _interopRequireWildcard(require("@material-ui/core"));

var MUIUtils = _interopRequireWildcard(require("@material-ui/core/utils"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

var MUILab = _interopRequireWildcard(require("@material-ui/lab"));

var MUIDataGrid = _interopRequireWildcard(require("@material-ui/data-grid"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _ButtonGroup = _interopRequireDefault(require("@material-ui/core/ButtonGroup"));

var _Card = _interopRequireDefault(require("@material-ui/core/Card"));

var _CardContent = _interopRequireDefault(require("@material-ui/core/CardContent"));

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _Container = _interopRequireDefault(require("@material-ui/core/Container"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _FormLabel = _interopRequireDefault(require("@material-ui/core/FormLabel"));

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _FormGroup = _interopRequireDefault(require("@material-ui/core/FormGroup"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));

var _LinearProgress = _interopRequireDefault(require("@material-ui/core/LinearProgress"));

var _ListItemIcon = _interopRequireDefault(require("@material-ui/core/ListItemIcon"));

var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));

var _Menu = _interopRequireDefault(require("@material-ui/core/Menu"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _Radio = _interopRequireDefault(require("@material-ui/core/Radio"));

var _RadioGroup = _interopRequireDefault(require("@material-ui/core/RadioGroup"));

var _Select = _interopRequireDefault(require("@material-ui/core/Select"));

var _Snackbar = _interopRequireDefault(require("@material-ui/core/Snackbar"));

var _SnackbarContent = _interopRequireDefault(require("@material-ui/core/SnackbarContent"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _ToggleButton = _interopRequireDefault(require("@material-ui/lab/ToggleButton"));

var _ToggleButtonGroup = _interopRequireDefault(require("@material-ui/lab/ToggleButtonGroup"));

var BaseAdapterExports = _interopRequireWildcard(require("../data_adapters/BaseAdapter"));

var BaseFeatureDetail = _interopRequireWildcard(require("../BaseFeatureWidget/BaseFeatureDetail"));

var _Base1DViewModel = _interopRequireDefault(require("../util/Base1DViewModel"));

var _ViewType = _interopRequireDefault(require("../pluggableElementTypes/ViewType"));

var _AdapterType = _interopRequireDefault(require("../pluggableElementTypes/AdapterType"));

var _DisplayType = _interopRequireDefault(require("../pluggableElementTypes/DisplayType"));

var _TrackType = _interopRequireDefault(require("../pluggableElementTypes/TrackType"));

var _WidgetType = _interopRequireDefault(require("../pluggableElementTypes/WidgetType"));

var pluggableElementTypeModels = _interopRequireWildcard(require("../pluggableElementTypes/models"));

var ServerSideRendererType = _interopRequireWildcard(require("../pluggableElementTypes/renderers/ServerSideRendererType"));

var _CircularChordRendererType = _interopRequireDefault(require("../pluggableElementTypes/renderers/CircularChordRendererType"));

var BoxRendererType = _interopRequireWildcard(require("../pluggableElementTypes/renderers/BoxRendererType"));

var FeatureRendererType = _interopRequireWildcard(require("../pluggableElementTypes/renderers/FeatureRendererType"));

var RendererType = _interopRequireWildcard(require("../pluggableElementTypes/renderers/RendererType"));

var Configuration = _interopRequireWildcard(require("../configuration"));

var Plugin = _interopRequireWildcard(require("../Plugin"));

var coreUi = _interopRequireWildcard(require("../ui"));

var coreUtil = _interopRequireWildcard(require("../util"));

var coreColor = _interopRequireWildcard(require("../util/color"));

var trackUtils = _interopRequireWildcard(require("../util/tracks"));

var coreIo = _interopRequireWildcard(require("../util/io"));

var coreMstReflection = _interopRequireWildcard(require("../util/mst-reflection"));

var rxjs = _interopRequireWildcard(require("../util/rxjs"));

var MUIColors = _interopRequireWildcard(require("./material-ui-colors"));

var mstTypes = _interopRequireWildcard(require("../util/types/mst"));

var _list = _interopRequireDefault(require("./list"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// this is all the stuff that the pluginManager re-exports for plugins to use
// @material-ui components
// material-ui lab
var libs = {
  mobx: mobx,
  'mobx-state-tree': mst,
  react: _react.default,
  'react-dom': ReactDom,
  'mobx-react': mxreact,
  'prop-types': _propTypes.default,
  // material-ui 1st-level components
  '@material-ui/core': MUICore,
  // special case so plugins can easily use @material-ui/icons; don't remove
  '@material-ui/core/SvgIcon': _SvgIcon.default,
  '@material-ui/core/utils': MUIUtils,
  // end special case
  '@material-ui/lab': MUILab,
  '@material-ui/data-grid': MUIDataGrid,
  // material-ui subcomponents, should get rid of these
  '@material-ui/core/colors': MUIColors,
  '@material-ui/core/styles': MUIStyles,
  '@material-ui/core/Box': _Box.default,
  '@material-ui/core/Button': _Button.default,
  '@material-ui/core/ButtonGroup': _ButtonGroup.default,
  '@material-ui/core/Card': _Card.default,
  '@material-ui/core/CardContent': _CardContent.default,
  '@material-ui/core/Container': _Container.default,
  '@material-ui/core/Checkbox': _Checkbox.default,
  '@material-ui/core/Dialog': _Dialog.default,
  '@material-ui/core/FormGroup': _FormGroup.default,
  '@material-ui/core/FormLabel': _FormLabel.default,
  '@material-ui/core/FormControl': _FormControl.default,
  '@material-ui/core/FormControlLabel': _FormControlLabel.default,
  '@material-ui/core/Grid': _Grid.default,
  '@material-ui/core/Icon': _Icon.default,
  '@material-ui/core/IconButton': _IconButton.default,
  '@material-ui/core/InputAdornment': _InputAdornment.default,
  '@material-ui/core/LinearProgress': _LinearProgress.default,
  '@material-ui/core/ListItemIcon': _ListItemIcon.default,
  '@material-ui/core/ListItemText': _ListItemText.default,
  '@material-ui/core/Menu': _Menu.default,
  '@material-ui/core/MenuItem': _MenuItem.default,
  '@material-ui/core/RadioGroup': _RadioGroup.default,
  '@material-ui/core/Radio': _Radio.default,
  '@material-ui/core/Select': _Select.default,
  '@material-ui/core/Snackbar': _Snackbar.default,
  '@material-ui/core/SnackbarContent': _SnackbarContent.default,
  '@material-ui/core/TextField': _TextField.default,
  '@material-ui/core/Tooltip': _Tooltip.default,
  '@material-ui/core/Typography': _Typography.default,
  // @material-ui lab
  '@material-ui/lab/ToggleButton': _ToggleButton.default,
  '@material-ui/lab/ToggleButtonGroup': _ToggleButtonGroup.default,
  '@jbrowse/core/Plugin': Plugin,
  '@jbrowse/core/pluggableElementTypes/ViewType': _ViewType.default,
  '@jbrowse/core/pluggableElementTypes/AdapterType': _AdapterType.default,
  '@jbrowse/core/pluggableElementTypes/DisplayType': _DisplayType.default,
  '@jbrowse/core/pluggableElementTypes/TrackType': _TrackType.default,
  '@jbrowse/core/pluggableElementTypes/WidgetType': _WidgetType.default,
  '@jbrowse/core/pluggableElementTypes/models': pluggableElementTypeModels,
  '@jbrowse/core/pluggableElementTypes/renderers/ServerSideRendererType': ServerSideRendererType,
  '@jbrowse/core/pluggableElementTypes/renderers/CircularChordRendererType': _CircularChordRendererType.default,
  '@jbrowse/core/pluggableElementTypes/renderers/BoxRendererType': BoxRendererType,
  '@jbrowse/core/pluggableElementTypes/renderers/FeatureRendererType': FeatureRendererType,
  '@jbrowse/core/pluggableElementTypes/renderers/RendererType': RendererType,
  '@jbrowse/core/configuration': Configuration,
  '@jbrowse/core/util/types/mst': mstTypes,
  '@jbrowse/core/ui': coreUi,
  '@jbrowse/core/util': coreUtil,
  '@jbrowse/core/util/color': coreColor,
  '@jbrowse/core/util/tracks': trackUtils,
  '@jbrowse/core/util/Base1DViewModel': _Base1DViewModel.default,
  '@jbrowse/core/util/io': coreIo,
  '@jbrowse/core/util/mst-reflection': coreMstReflection,
  '@jbrowse/core/util/rxjs': rxjs,
  '@jbrowse/core/BaseFeatureWidget/BaseFeatureDetail': BaseFeatureDetail,
  '@jbrowse/core/data_adapters/BaseAdapter': BaseAdapterExports
}; // make sure that all the items in the ReExports/list array (used by build systems and such)
// are included here. it's OK if there are some additional ones that are not in the list

_list.default.forEach(function (name) {
  if (!(name in libs)) {
    throw new Error("ReExports/modules is missing ".concat(name));
  }
});

var _default = libs;
exports.default = _default;